<template>
<div class="site-drawer">
  
  <div v-on:click="$teras.app.drawer=false" class="yo-text-l yo-bg-color-primary white yo-align-center">
		<!-- <div style="float:right;padding:8px 8px 0 0;"><span class="material-icons" >clear</span></div> -->
		<div class="yo-valign-text-center" style="height:64px;">FUNZIONI DISPONIBILI</div>
  </div>


  <el-menu default-active="-1" class="app-side-menu" :router="true">

    <el-menu-item index="/home" v-if="$route.path!='/home'">Home</el-menu-item>
    <el-menu-item index="/contatto-edit">Modifica Profilo</el-menu-item>
    <el-menu-item index="/contatto-password">Cambia Password</el-menu-item>
    <el-menu-item index="/contatto-rinnovo">Rinnovo e nuove Adesioni</el-menu-item>
    <li class="el-menu-item" @click="$teras.event.emit('logout')">Esci</li>

  </el-menu>



</div>
</template>

<script>
export default {
  name: 'site-drawer',
}
</script>
